import React from 'react';

const ButtonIconFlat = ({ children, onClick }) => {
    return(
        <button className="appButton__iconFlat" type="button" onClick={onClick}>
            {children}
        </button>
    )
}

export default ButtonIconFlat;